module.exports = __webpack_public_path__ + "img/phone.a5bfe83b.svg";